var _circle, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPausedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 28,
    fill: "#F8EDC8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 20,
    width: 5,
    height: 22,
    rx: 2,
    fill: "none",
    stroke: "#E39A20",
    strokeWidth: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 20,
    width: 5,
    height: 22,
    rx: 2,
    fill: "none",
    stroke: "#E39A20",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPausedIcon);
export default __webpack_public_path__ + "static/media/paused-icon.903a162f82c6744b6dd8b362d51c53bd.svg";
export { ForwardRef as ReactComponent };